import DropdownTemplateView from '../../../../DropdownTemplateView'
import SimpleTwoOptionsMenu from '../../../../components/SimpleTwoOptionsMenu'
import messageResource from '../../../../messageResource'
import $ from 'jquery'

export default class RegularNonworkingDayEditor extends DropdownTemplateView {
    constructor({
        editCallback = () => {},
        deleteCallback = () => {},
    } = {}) {
        super()

        this.callbacks = {
            editCallback,
            deleteCallback,
        }

        this.state = {
            date: null,
            nonStandardWorking: false,
        }

        this.onStatePropertyChanged('nonStandardWorking', (isWorking) => {
            this.simpleMenu.setState({
                firstTitle: messageResource.getMessage(isWorking ? 'work_schedule.mark_as_regular_nonworking_day' : 'work_schedule.mark_as_working_day'),
            })
        })
    }

    templateHtml() {
        return "<div class='regularNonworkingDayEditorContainer'/>"
    }

    afterRender() {
        this.simpleMenu = new SimpleTwoOptionsMenu({
            additionalClass: 'regularNonworkingDayEditor',
            onFirstOptionSelected: () => {
                if (this.state.nonStandardWorking) {
                    this.callbacks.deleteCallback(this.state.date)
                } else {
                    this.callbacks.editCallback(this.state.date, true, '')
                }
                this.hide()
            },
            onSecondOptionSelected: () => {
                this.callbacks.editCallback(this.state.date, false, messageResource.getMessage('work_schedule.corporate_holiday'))
                this.hide()
            },
        }).init(this.$el)

        this.simpleMenu.setState({
            secondTitle: messageResource.getMessage('work_schedule.mark_as_holiday'),
        })

        this.renderInitialState()
    }

    setOnHideCallback(callback) {
        this.onHideCallback = callback
    }

    setOnShowCallback(callback) {
        this.onShowCallback = callback
    }

    onHide() {
        super.onHide()
        this.onHideCallback()
    }

    onShow() {
        super.onShow()
        this.onShowCallback()
    }

    mouseDownTargetElement() {
        return $(document)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/month/RegularNonworkingDayEditor.js